import React from "react";
import imgUrl from "../layout/img/logo.svg";
import "./style.css";

export default function Header() {
  return (
    <header className="st-Header">
      <div className="st-Header_Inner sw-FlexBox st-Header_Bet st-Header_Pc">
        <div className="st-Header_LogoWrap sw-FlexBox">
          <a href="/" className="st-Header_LogoLink">
            <h1 className="st-Header_Logo">
              <img src={imgUrl} alt="ハロー!RENOVATION" />
            </h1>
          </a>
          <p className="st-Header_SubTitle">
            まちづくり参加型クラウドファンディング
          </p>
        </div>
        <div className="st-Header_Nav sw-FlexBox">
          <a href=" /about" className="st-Header_Link-About">
            ハロー！RENOVATIONとは？
          </a>
          {/* <ul className="st-Header_Login login-List no-Login">
            <li className="login-Item login-Item_Signup">
              <a href="/user/registration" className="signup-Button">
                新規会員登録
              </a>
            </li>
            <li className="login-Item login-Item_Login">
              <a href="/user/login" className="login-Button">
                ログイン
              </a>
            </li>
          </ul>
          <div className="st-Header_MyAccount">
            <img src="" alt="ユーザアイコン" />
          </div>
          <ul className="st-Header_MyAccountMenu">
            <li className="st-Header_MyAccountMenu-Item">
              <a href="/members/">マイページ</a>
            </li>
            <li className="st-Header_MyAccountMenu-Item">
              <a href="/members/profile">プロフィール編集</a>
            </li>
            <li className="st-Header_MyAccountMenu-Item">
              <a href="/user/logout">ログアウト</a>
            </li>
          </ul> */}
        </div>
      </div>
    </header>
  );
}



// WEBPACK FOOTER //
// ./src/components/layout/Header.js